"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardBuilder = void 0;
const WizardInteractor_1 = require("./WizardInteractor");
const WizardRouter_1 = require("./WizardRouter");
class WizardBuilder {
    constructor(deps) {
        this.deps = deps;
    }
    build() {
        var _a, _b, _c, _d, _e;
        const { viewController } = this.deps;
        const interactor = new WizardInteractor_1.WizardInteractor(null, this.deps.listener, viewController, {
            isNextStepAvailable: (_b = (_a = this.deps.config) === null || _a === void 0 ? void 0 : _a.isNextStepAvailable) !== null && _b !== void 0 ? _b : true,
            onStepChange: (_c = this.deps.config) === null || _c === void 0 ? void 0 : _c.onStepChange,
            prioritizeUseActionsState: (_e = (_d = this.deps.config) === null || _d === void 0 ? void 0 : _d.prioritizeUseActionsState) !== null && _e !== void 0 ? _e : false
        });
        viewController.listener = interactor;
        const router = new WizardRouter_1.WizardRouter(interactor, viewController, this.deps.steps);
        return {
            router,
            actionable: interactor
        };
    }
}
exports.WizardBuilder = WizardBuilder;
//# sourceMappingURL=WizardBuilder.js.map